import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;


@Component({
  selector: 'app-story',
  templateUrl: './story.component.html',
  styleUrls: ['./story.component.css']
})
export class StoryComponent implements OnInit {
  nao = new Nanobar();
  storyData: any;
  storyDeleteData: any;
  deleteStoryId: any;
  loadindData = true;
  paginatedDataStory: any;
  storyPageCount = 0;
  storyLastPage = true;
  deleteBtndDisable = false;
  // dispensary_id: any;
  constructor(private dataService: DataService, private router: Router) { }
  getStory() {
    this.loadindData = true;
    this.nao.go(30);
    this.dataService.getStorylisting(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        this.storyData = data;
        this.storyLastPage = this.storyData.last_page;
        this.storyPageCount++;
        this.storyData = this.storyData.items;
        this.loadindData = false;
        
        // if ( this.storyData.dispensary_id < 0){
        //   this.dispensary_id = -1;
        // }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getStorylistingByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getStorylistingByPage(window.localStorage.getItem('token'), this.storyPageCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataStory = data;
        // this.limit = this.paginatedData.limit;
        this.storyLastPage = this.paginatedDataStory.last_page;
        this.storyPageCount++;
        this.paginatedDataStory = this.paginatedDataStory.items;
        for (var i = 0; i < this.paginatedDataStory.length; i++) {
          this.storyData.push(this.paginatedDataStory[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  openDeleteStoryPopup(id) {
    this.deleteStoryId = id;
    $('#deleteStoryPopup').modal('show');
  }
  deleteConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.deleteStory(window.localStorage.getItem('token'), this.deleteStoryId).subscribe(
      (data) => {
        this.nao.go(100);
        this.storyDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.storyDeleteData.success === true ) {
          this.getStory();
          $('#deleteStoryPopup').modal('hide');
        }
        this.getStory();
        $('#deleteStoryPopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  ngOnInit() {
    this.getStory();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#story').css('color', '#d77229');
  }

}



// WEBPACK FOOTER //
// ./src/app/story/story.component.ts